module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_27.b9864d0e.png";